export const GROWTHBOOK_EXPERIMENT_EVENT_NAME = 'Experiment.Participate'
